import React from 'react';
import { Box, Typography } from '@mui/material';
import { TrendingDown, TrendingUp } from '@mui/icons-material';

interface PercentageChangeProps {
  prev: number;
  current: number;
  lightText?: boolean;
}

function PercentageChange({
  prev,
  current,
  lightText
}: PercentageChangeProps): React.ReactElement {
  const divider = prev || 1;
  const percentageChange = ((current - prev) / divider) * 100;

  let IconComponent = null;

  if (percentageChange > 0) {
    IconComponent = <TrendingUp sx={{ fontSize: 18 }} color='secondary' />;
  } else if (percentageChange < 0) {
    IconComponent = <TrendingDown sx={{ fontSize: 18 }} color='error' />;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      {IconComponent}
      <Typography
        variant='body2'
        sx={{ fontSize: '.8rem', ml: 0.5 }}
        color={percentageChange < 0 ? 'error' : 'secondary'}
      >
        {percentageChange.toFixed(2)} %
      </Typography>
    </Box>
  );
}

export default PercentageChange;
